import { Link } from 'react-router-dom';

/**
 * Vitala Logo Component
 * Shows the full brand logo (leaves + Vitala text + beige background)
 */
export function Logo({ size = 'default', linkTo = '/', className = '' }) {
  const sizes = {
    small: 'h-14 md:h-16',
    default: 'h-16 md:h-[4.5rem]',
    large: 'h-20 md:h-24',
    xlarge: 'h-24 md:h-28'
  };

  const imgClass = sizes[size] || sizes.default;

  const logoContent = (
    <img 
      src="/logo-full.png" 
      alt="Vitala" 
      className={`${imgClass} w-auto object-contain rounded-lg ${className}`}
    />
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="hover:opacity-90 transition-opacity">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
}

export default Logo;
